<template>
  <transition
    name="accordion-transition"
    mode="out-in"
    :css="false"
    v-on:enter="enter"
    v-on:enter-cancelled="enterCancelled"
    v-on:leave="leave"
    v-on:leave-cancelled="leaveCancelled">
    <slot></slot>
  </transition>
</template>

<script>
export default {
  methods: {
    enter(el, done) {
      if (!this.$parent.collapse) {
        $(el).velocity('slideDown', {
          duration: 500,
          easing: [600, 25],
          complete: done,
        });
      } else {
        $(el).velocity('slideUp', {
          duration: 350,
          easing: 'ease-out',
          complete: done,
        });
      }
    },
    enterCancelled(el) {
      $(el).stop();
    },
    leave(el, done) {
      $(el).velocity('slideUp', {
        duration: 350,
        easing: 'ease-out',
        complete: done,
      });
    },
    leaveCancelled(el) {
      $(el).stop();
    },
  },
};
</script>
